class FindMyBreed extends HTMLElement {
  constructor() {
    super();
    this.searchInput = this.querySelector("[data-find-my-breed-search]");
    this.searchButton = this.querySelector("[data-find-my-breed-submit]");
    this.letterButtons = this.querySelectorAll(
      "button[data-find-my-breed-letter]",
    );
    this.items = this.querySelectorAll("[data-find-my-breed-item]");
    this.resultCount = this.querySelector("[data-find-my-breed-count]");
    this.emptyState = this.querySelector("[data-find-my-breed-empty]");
    this.activeLetter = "all";
    this.submittedQuery = "";
  }

  connectedCallback() {
    if (!this.items.length) return;

    this.searchButton?.addEventListener("click", () => this.submitSearch());

    this.searchInput?.addEventListener("keydown", (event) => {
      if (event.key !== "Enter" || event.isComposing) return;

      event.preventDefault();
      this.submitSearch();
    });

    this.searchInput?.addEventListener("input", () => {
      this.resetSearchFilterIfCleared();
    });

    this.searchInput?.addEventListener("search", () => {
      this.resetSearchFilterIfCleared();
    });

    this.letterButtons.forEach((button) => {
      button.addEventListener("click", () => {
        this.activeLetter = button.dataset.findMyBreedLetter || "all";
        this.updateLetterButtons(button);
        this.filterItems();
      });
    });

    this.filterItems();
  }

  submitSearch() {
    this.submittedQuery = (this.searchInput?.value || "").trim();
    this.filterItems();
  }

  resetSearchFilterIfCleared() {
    if ((this.searchInput?.value || "").trim() !== "") return;
    if (this.submittedQuery === "") return;

    this.submittedQuery = "";
    this.filterItems();
  }

  normalize(value) {
    return value
      .toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim()
      .toLowerCase();
  }

  updateLetterButtons(activeButton) {
    this.letterButtons.forEach((button) => {
      button.setAttribute(
        "aria-pressed",
        button === activeButton ? "true" : "false",
      );
    });
  }

  filterItems() {
    const query = this.normalize(this.submittedQuery);
    let visibleCount = 0;

    this.items.forEach((item) => {
      const itemSearch = this.normalize(item.dataset.findMyBreedSearch || "");
      const itemLetter = this.normalize(item.dataset.findMyBreedLetter || "");
      const matchesSearch = query === "" || itemSearch.includes(query);
      const matchesLetter =
        this.activeLetter === "all" || itemLetter === this.activeLetter;
      const isVisible = matchesSearch && matchesLetter;

      item.hidden = !isVisible;

      if (isVisible) {
        visibleCount += 1;
      }
    });

    this.updateResultCount(visibleCount);

    if (this.emptyState) {
      this.emptyState.hidden = visibleCount !== 0;
    }

    return visibleCount;
  }

  updateResultCount(visibleCount) {
    if (!this.resultCount) return;

    const oneTemplate =
      this.resultCount.dataset.countOne || "[count] breed shown";
    const otherTemplate =
      this.resultCount.dataset.countOther || "[count] breeds shown";
    const template = visibleCount === 1 ? oneTemplate : otherTemplate;

    this.resultCount.textContent = template.replace("[count]", visibleCount);
  }
}

if (!customElements.get("find-my-breed")) {
  customElements.define("find-my-breed", FindMyBreed);
}
